import { render, staticRenderFns } from "./CommentaryMainTab.vue?vue&type=template&id=db3a4970&scoped=true"
import script from "./CommentaryMainTab.vue?vue&type=script&lang=js"
export * from "./CommentaryMainTab.vue?vue&type=script&lang=js"
import style0 from "./CommentaryMainTab.vue?vue&type=style&index=0&id=db3a4970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3a4970",
  null
  
)

export default component.exports